import type { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'

type CssFn = ReturnType<typeof useStyletron>[0]

export const tableShellClass = (css: CssFn): string =>
  css({
    borderCollapse: 'collapse',
    backgroundColor: palette.white,
    border: `1px solid ${palette.grey30}`,
    borderRadius: '4px',
    overflow: 'hidden',
  })

export const tableHeaderCellClass = (css: CssFn): string =>
  css({
    textAlign: 'left',
    padding: '12px 16px',
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '14px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: palette.grey70,
    backgroundColor: palette.grey05,
    borderBottom: `1px solid ${palette.grey30}`,
    whiteSpace: 'nowrap',
  })

export const tableRowHoverClass = (css: CssFn): string =>
  css({ ':hover': { backgroundColor: palette.grey05 } })

export const tableBodyCellClass = (css: CssFn, isLastRow: boolean): string =>
  css({
    padding: '14px 16px',
    fontSize: '14px',
    color: palette.grey70,
    verticalAlign: 'middle',
    borderBottom: isLastRow ? 'none' : `1px solid ${palette.grey20}`,
  })
